import {intlShape, loginContainer, SubmitButton, utils} from '@wallaby-ui/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
import {defineMessages, injectIntl, FormattedMessage} from 'react-intl';
import stylesButton from 'src/js/containers/auto_layout/components/SaveDeleteButtons.less';

import styles from './ArrayScreenWrapperAddButton.less';

const I18N = defineMessages({
  ADD_BUTTON: {
    id: 'autoLayout.arrayWrapper.button.add',
    defaultMessage: 'Add item',
    description: 'text for auto layout array container add button',
  },
});

const ArrayScreenWrapperAddButton = ({intl, isDisabled, onAdd}) => (
  <SubmitButton
    className={classNames(styles.dlArrayAddButton)}
    alignSelf={'stretch'}
    isPrimary={false}
    onClick={onAdd}
    dataName={'addScreenButton'}
    disabled={isDisabled}
    title={utils.TranslateUtils.translate(I18N.ADD_BUTTON, intl)}
  >
    <span className={classNames(stylesButton.dlButtonTextLight)}>
      <i
        className={classNames(stylesButton.dlButtonIcon, 'fas fa-plus fa-fw')}
      />
      <span className={stylesButton.dlBoldText}>
        <FormattedMessage {...I18N.ADD_BUTTON} />
      </span>
    </span>
  </SubmitButton>
);

ArrayScreenWrapperAddButton.displayName = 'ArrayScreenWrapperAddButton';

ArrayScreenWrapperAddButton.propTypes = {
  isDisabled: PropTypes.bool,
  onAdd: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
};

ArrayScreenWrapperAddButton.defaultProps = {
  isDisabled: false,
};

export default injectIntl(ArrayScreenWrapperAddButton);
